////namespace Gordic.Epk.WebControls {

////    const { gcontent } = Decorators;

////    @gcontent
////    export class GEpkReportFormControl extends GContentBase {

////        private gfrm;
////        private _options;
////        private _srv;
////        private viewmode;
////        private chto;

////        public onClose() {
////            Gordic.ResizeManager.unobserve(this.element.get(0), "gfrmresize");
////            this._srv.fire("Free", { Form: this._options.Form });
////        }

////        public prepareContent(options) {

////            var _content = this;
////            var $div = $("<div>").appendTo(_content.element);
////            _content.gfrm = $div;
////            $div.addClass("gfrm")
////                .on({
////                    "focusin": function (e) { $(e.target).closest(".gfield").addClass("gfrm-field-focus"); },
////                    "focusout": function (e) { $(e.target).closest(".gfield").removeClass("gfrm-field-focus"); }
////                }, ".gfield");
////            console.log("Gordic.Report.WebClient.GReportFormControl.prepareContent", this, options);

////            this.newOps({ title: "jres:32000825" + " " + options.Form }); //RC 32000825 : Formulář


////            this.actions.addRange({
////                //refreshAct: {
////                //    caption: "Refresh",
////                //    run: function (ev, ctx) {
////                //        this.setPending(_content.refresh()
////                //            .then(function (saved) {
////                //                console.log("Refresh OK");
////                //            })
////                //        );
////                //    }
////                //},
////                saveAct: {
////                    caption: "jres:32000826", //RC 32000826 : Uložit
////                    run: function (ev, ctx) {
////                        debugger;
////                        this.setPending(_content.save()
////                            .then(function (saved) {
////                                console.log("Save OK");
////                            })
////                        );
////                    }
////                }
////            });

////            this.menuBar([
////                //{ action: this.actions.refreshAct, favorite: true },
////                { action: this.actions.saveAct, favorite: true },
////            ]);

////            //sluzba pro pristup k datum ze serveru
////            _content._srv = this.createServiceContent(options.server || "Gordic.Report.WebClient.GReportFormControl");
////            _content._options = options;

////            $div.gtooltip({
////                mode: "attribute",
////                items: "[title]",
////                tooltipAttr: "title",
////                //track: true,
////                beforeTooltip: function (ev, context) {
////                    var emsg = $(ev.target).data("error-msg");
////                    if (emsg) {
////                        context.state = "error";
////                        context.tooltip += "<label class='gform-error-report'><i class='fa fa-times-circle g-state-background g-state-error gform-error-icon'></i>" + emsg + "</label>";
////                    }
////                    return context;
////                }
////            });

////            _content.viewmode = 0;
////            _content.firstLoad();

////            _content.element.on("scroll", function (ev) {
////                if (this === ev.target)
////                    $(this).find(".js-gfrm-wait").each(function (i, e) {
////                        var $e = $(e);
////                        if ($e.visible(true)) {
////                            var $page = $e.parent();
////                            var p = parseInt($page.attr('data-page-num'));
////                            $e.toggleClass('js-gfrm-wait');
////                            console.log("scroll load " + p);
////                            _content._delayload(p, $e, $page, "delay render");
////                        }
////                    });
////            });

////            //resizeManager
////            var fitVobs = {
////                id: "gfrmresize",
////                isActive: function (contentRect, prevContentRect, lastActiveContentRect) {
////                    return lastActiveContentRect == null || contentRect.height !== lastActiveContentRect.height;
////                },
////                execute: function (contentRect, prevContentRect, lastActiveContentRect) {
////                    _content._scanzoom();
////                },
////                wait: 100
////            };
////            Gordic.ResizeManager.observe(_content.element.get(0), fitVobs);

////            GBrowserExtras.isSupportedPromise("sign")
////                .done(function (sup) {
////                    _content.actions.saveSignedPdfAct.enabled(sup);
////                });
////            return false;

////        }

////        public save() {
////            console.log("save");
////            var _content = this;
////            var c = _content.chto;
////            if (c) clearTimeout(_content.chto);
////            return _content._srv.call("Save", { Form: _content._options.Form, Data: _content.collect() })
////                .then(function (saved) {
////                    //console.log("save done", saved);
////                    _content._setData(saved);
////                    if (c) _content.reload();
////                    _content.element.trigger("greportformcontrolsaved", [saved]); //NOTE (martinekb): DSebesta se na tuto udalost chyta, pry si sem muzeme psat jak chceme :-)
////                });
////        }

////        public reload(rp) {
////            var _content = this;
////            if (_content.chto) clearTimeout(_content.chto);
////            var l = $(".js-gfrm-load").length == 0;
////            var ret = $.Deferred().resolve().promise();
////            _content.element.find(".gfrm-img,.js-gfrm-load").each(function (i, e) {
////                var $e = $(e);
////                var $page = $e.parent();
////                var p = parseInt($page.attr('data-page-num'));
////                if ($e.visible(true)) {
////                    if (l && (!rp || rp == p)) {
////                        console.log("reload " + p);
////                        ret = _content._delayload(p, $e, $page, "reload render");
////                        l = false;
////                    }
////                    else {
////                        console.log("reload " + p, "queued");
////                        $e.addClass('js-gfrm-reload');
////                    }
////                }
////                else {
////                    $e.removeClass('gfrm-img');
////                    $e.addClass('js-gfrm-wait');
////                    console.log("reload wait " + p);
////                }
////            });
////            return ret;
////        }

////        private _delayload(p, $e, $page, txt, cmd) {
////            var _content = (this as any);
////            $e.removeClass('gfrm-img js-gfrm-reload');
////            $e.addClass('js-gfrm-load');
////            return _content._srv.call("RenderPage", { Form: _content._options.Form, Page: p, Width: WIDTHMAGIC * (window.devicePixelRatio || 1), MapWidth: WIDTHMAGIC, Data: _content.collect(), Exec: cmd })
////                .fail(console.log)
////                .then(function (render) {
////                    console.log(txt + " " + p, render);
////                    if ($e.is(".js-gfrm-reload"))
////                        return _content._delayload(p, $e.removeClass('js-gfrm-reload'), $page, "rereload render self");
////                    if (_content._zoom($e, render.Width)) {
////                        var $old = $page.children("img,map,.js-gfrm-load");
////                        var contentId = _content._srv.element.attr("id");
////                        var $n = $("<img class='gfrm-img' width='" + PageWidth + "' height='" + Math.round(PageWidth * render.Height / render.Width) + "' render-width='" + render.Width + "' render-height='" + render.Height + "' src= 'data:image/png;base64," + render.Image + "' usemap='#" + contentId + "-gfrm-map-" + p + "'>")
////                            .on('dragstart', function (event) { event.preventDefault(); })
////                            .appendTo($page)
////                            ;
////                        $old.addClass("gfrm-abs");
////                        $(render.Map).on("click", _content._execute1).appendTo($page);
////                        try {
////                            _content._inputs(render, $page, p);
////                            if ($page.is(document.activeElement)) {
////                                $page.find(":tabbable:first").focus();
////                            }
////                            $page.attr("tabindex", null);
////                        }
////                        finally {
////                            $old.remove();
////                        }
////                    }
////                    else {
////                        console.log(txt + " failed " + p, render);
////                    }
////                    var $rr = _content.find(".js-gfrm-reload").eq(0);
////                    if ($rr.length) {
////                        var $pager = $rr.parent();
////                        var pp = parseInt($pager.attr('data-page-num'));
////                        return _content._delayload(pp, $rr, $pager, "rereload render");
////                    }
////                    return render;
////                })
////                .fail(function (render) {
////                    $e.removeClass('js-gfrm-load js-gfrm-reload').addClass('gfrm-img');
////                });
                
////        }

////    }

  

////}